module.exports = "/_next/static/images/9-1-577b9bc0885612c34a6ee73d3e523e9b.svg";